import {useForm} from "react-hook-form";
import styled from "styled-components";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  height: 38px;
  border-radius: 4px;
  border: 1px solid #c0c0c0;
  padding: 6px 12px;
  width: 120px;
  font-size: 16px;
`;

const Label = styled.label`
  display: block;
  width: 130px;
`;

const ButtonBox = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;

  button {
    width: 80px;
    height: 38px;
    border-radius: 4px;
    font-size: 16px;
    background-color: #564DE6;
    color: #ffffff;
  }
`;

interface ControllerProps {
  values: {fps: number, contrast: number, brightness: number};
  onValuesChange: (newValues: {fps: number, contrast: number, brightness: number}) => void;
}

interface FormValues {
  fps: number;
  contrast: number;
  brightness: number;
}

export default function Controller({values: {fps, contrast, brightness}, onValuesChange}: ControllerProps) {
  const {register, handleSubmit, reset} = useForm<FormValues>({
    defaultValues: {
      fps,
      contrast,
      brightness
    }
  });

  const onValid = (values: FormValues) => {
    onValuesChange(values);
  }

  return <Form onSubmit={handleSubmit(onValid)}>
    <InputWrapper>
      <Label>{`FPS`}</Label>
      <Input {...register("fps")} type="number" />
    </InputWrapper>
    <InputWrapper>
      <Label>{`대비 (%, 0이상)`}</Label>
      <Input {...register("contrast")} type="number" />
    </InputWrapper>
    <InputWrapper>
      <Label>{`밝기 (%, 0이상)`}</Label>
      <Input {...register("brightness")} type="number" />
    </InputWrapper>
    <ButtonBox>
      <button>확인</button>
      <button type="button" style={{backgroundColor: "#a0a7c0"}} onClick={() => reset()}>초기화</button>
    </ButtonBox>
  </Form>
}